import { Megaphone, CheckCircle, XCircle, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAdmin } from './AdminContext';
import { StatusBadge } from './AdminShared';

export const AdminPromotersTab = () => {
  const { promoterRegistrations, updateRegistrationStatus, deleteRegistration } = useAdmin();

  return (
    <>
      <h2 className="text-xl font-semibold mb-4">Promoter Registrations ({promoterRegistrations.length})</h2>
      {promoterRegistrations.length === 0 ? (
        <Card className="bg-card border-border">
          <CardContent className="py-12 text-center">
            <Megaphone size={48} className="mx-auto text-muted-foreground mb-4" />
            <h3 className="text-lg font-semibold mb-2">No promoter registrations yet</h3>
            <p className="text-muted-foreground">When event promoters register, they will appear here for approval.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {promoterRegistrations.map(promoter => (
            <Card key={promoter.id} className="bg-card border-border">
              <CardHeader className="pb-2">
                <div className="flex items-center justify-between">
                  <CardTitle className="text-lg">{promoter.company_name}</CardTitle>
                  <StatusBadge status={promoter.status} />
                </div>
                <CardDescription>{promoter.contact_name} - {promoter.email}</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground mb-2 line-clamp-2">{promoter.description}</p>
                {promoter.event_types && <p className="text-xs text-muted-foreground mb-2">Events: {promoter.event_types}</p>}
                {promoter.status === 'pending' && (
                  <div className="flex gap-2">
                    <Button size="sm" variant="outline" className="flex-1" onClick={() => updateRegistrationStatus('promoter-registrations', promoter.id, 'approved')}><CheckCircle size={14} className="mr-1" /> Approve</Button>
                    <Button size="sm" variant="destructive" className="flex-1" onClick={() => updateRegistrationStatus('promoter-registrations', promoter.id, 'rejected')}><XCircle size={14} className="mr-1" /> Reject</Button>
                  </div>
                )}
                {promoter.status === 'approved' && <Badge className="bg-green-500/20 text-green-500">Verified Promoter</Badge>}
                <Button size="sm" variant="ghost" className="w-full text-destructive hover:text-destructive text-xs mt-2" onClick={() => deleteRegistration('promoter-registrations', promoter.id)}><Trash2 size={12} className="mr-1" /> Delete</Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </>
  );
};
